<template>
  <div class="board-md" >
    <div v-if="dataMap.bank_view_data && dataMap.bank_view_data.length>0">
      <Divider orientation="left">常用银行卡校验</Divider>
      <Table border disabled-hover :columns="transferSummary" :data="dataMap.bank_view_data"></Table>
    </div>
    <Divider orientation="left">账单校验</Divider>
    <Table border disabled-hover :columns="uploadColumns" :data="dataMap.uploadLog"></Table>
    <div v-if="boardData && boardData.settlementMapList && boardData.settlementMapList.length>0">
      <Divider orientation="left">结息校验</Divider>
      <Table border disabled-hover :columns="settlement" :data="boardData.settlementMapList"></Table>
    </div>
    <Divider orientation="left">司法与不良嗜好校验</Divider>
    <Table border disabled-hover :columns="badHabit" :data="badHabitData"></Table>
  </div>
</template>
<script>
export default {
  props: {
    dataMap: Object,
    homeStat: Object,
    score: Object,
    boardData: Object
  },
  data () {
    return {
      uploadColumns:
        [{
          type: 'html',
          key: 'billType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '账单<br/>类型'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }, {
          key: 'name',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '姓名')
            ])
          }
        }, {
          key: 'bankCardNo',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '账户')
            ])
          }
        }, {
          key: 'signNums',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '电子签')
            ])
          }
        }, {
          key: 'continuity',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '余额')
            ])
          }
        }],
      transferSummary:
        [{
          type: 'html',
          key: 'businessType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '银行<br/>卡号'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '支出')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '收入')
            ])
          }
        }, {
          type: 'html',
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '交易<br/>金额'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }, {
          type: 'html',
          key: 'billAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '交叉<br/>检验'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            return h('div', [
              h('div', params.row.billAvg === 'Y' ? '通过' : (params.row.billAvg === 'N' ? '未通过' : ''))
            ])
          }
        }],
      settlement:
        [{
          key: 'statTime',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '结息日期')
            ])
          }
        }, {
          key: 'money',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '金额')
            ])
          }
        }, {
          key: 'yearAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '利率')
            ])
          }
        }, {
          key: 'billType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '是否有效结息')
            ])
          }
        }, {
          key: 'monthAvg',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '计算结息')
            ])
          }
        }, {
          key: 'dayAvg',
          className: 'table-header-cell-mb',
          render: (h, params) => {
            return h('div', [
              h('suibianxie', params.row.dayAvg ? params.row.dayAvg + '%' : '')
            ])
          },
          renderHeader: (h, params) => {
            return h('div', [
              h('strong', '偏差率')
            ])
          }
        }],
      badHabit:
        [{
          type: 'html',
          key: 'billType',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '娱乐<br/>校验'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }, {
          type: 'html',
          key: 'name',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '高频<br/>转账'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }, {
          type: 'html',
          key: 'bankCardNo',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '夜间<br/>交易'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }, {
          type: 'html',
          key: 'pwan',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '典当<br/>交易'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }, {
          type: 'html',
          key: 'judicial',
          className: 'table-header-cell-mb',
          renderHeader: (h, params) => {
            var text = '司法<br/>校验'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        }],
      badHabitData: [ {
        billType: '涉及金额:￥' + this.homeStat.blackTrade.leisureEntertainment.money + '元',
        name: '涉及金额:￥' + this.homeStat.blackTrade.highFrequencyTransfer.money + '元',
        bankCardNo: '涉及金额:￥' + this.homeStat.blackTrade.nightTradeList.money + '元',
        pwan: '涉及金额:￥' + this.homeStat.blackTrade.pawnTradingList.money + ' 元',
        judicial: '涉及金额:￥' + this.homeStat.blackTrade.judicialFreeze.money + ' 元'
      }, {
        billType: this.getBlackTradeResult(this.homeStat.blackTrade.leisureEntertainment.money),
        name: this.getBlackTradeResult(this.homeStat.blackTrade.highFrequencyTransfer.money),
        bankCardNo: this.getBlackTradeResult(this.homeStat.blackTrade.nightTradeList.money),
        pwan: this.getBlackTradeResult(this.homeStat.blackTrade.pawnTradingList.money),
        judicial: this.getBlackTradeResult(this.homeStat.blackTrade.judicialFreeze.money)
      }
      ]
    }
  },
  mounted: function () {
  },
  methods: {
    getBlackTradeResult (money) {
      if (money === '0') {
        return '通过'
      } else {
        return '存在,请重点关注'
      }
    }
  }
}
</script>
<style>

.ivu-table td {
  background-color: #F5F5F5;
}
.ivu-table th.table-header-cell-mb {
  background: #1242CD;
  font-family: Microsoft YaHei;
  font-size: 12pt;
  color: #FFFFFF;
  text-align: center;
  border: #1242CD;
}
.board-md {
  margin-bottom: 20pt;
}
</style>
